export const fphEmailDomain = "@fphcare.";
